import { IModel } from "maps-angular-components";

export interface StatusProcessamentoDTO {
  enum: string,
  name: string
}

export class StatusProcessamento implements IModel {
  enum: string;
  name: string;

  constructor(obj: StatusProcessamentoDTO) {
    this.enum = obj.enum;
    this.name = obj.name;
  }

  getId(): string {
    return this.enum;
  }

  getName(): string {
    return this.name;
  }

  equals(obj: IModel): boolean {
    return this.getId() === obj.getId();
  }

  toJSON() {
    return Object.assign(this);
  }
}

export const listaStatusProcessamento: StatusProcessamento[] = [
  new StatusProcessamento({enum: "DESENQUADRADA", name: "Desenquadrada"}),
  new StatusProcessamento({enum: "ENQUADRADA", name: "Enquadrada"}),
  new StatusProcessamento({enum: "NAO_PROCESSADA", name: "Não processada"}),
  new StatusProcessamento({enum: "ERRO", name: "Pendente"}),
  new StatusProcessamento({enum: "PROCESSANDO", name: "Processando"})
];

